<article class="bg-blue-primary grid gap-2 rounded-sm p-2.5 shadow-[0px_3px_6px_0px_#00000065]">
  <img
    class="image mx-auto w-32"
    [src]="user().avatar"
    alt="icon" />

  <div class="header flex items-center justify-between">
    <p class="font-barlow text-center text-sm leading-5 font-bold text-gray-100 italic">
      {{ user().name | uppercase }}
    </p>

    <div
      class="bg-gray-slate flex items-center rounded-full px-3 py-1 text-sm shadow-md"
      style="box-shadow: 0px 1px 3.2px 0px #00000040">
      <icon name="helmet-icon" />
      <span class="ml-1">{{ user().totalUsers }}</span>
    </div>
  </div>

  <div class="footer">
    @let score = user().summary?.percentage ?? 0;
    <score [score]="score"></score>
    <div class="my-2">
      <progress-bar [progress]="score"></progress-bar>
    </div>
  </div>
</article>
